import { StyledSVG } from '../../Atoms/SVG/styles'
import { styled } from '../../Styles/stitches.config'

export const AccordionButton = styled('div', {
    alignItems: 'center',
    color: '$primary600',
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    fontSize: '1.125rem',
    justifyContent: 'space-between',
    p: '$3',
    transition: '$default',
})

export const AccordionContent = styled('div', {
    p: '0 $3 $3',
    transition: '$default',
})

export const ArrowWrapper = styled('div', {
    alignItems: 'center',
    display: 'flex',

    [`& ${StyledSVG}`]: {
        mr: '$1',
        transition: '$default',
        w: 16,
    },
})

export const StyledAccordion = styled('div', {
    br: '$1',
    overflow: 'hidden',
    transition: '$default',

    variants: {
        disabled: {
            true: {
                border: '1px solid $neutral50',
                color: '$neutral300',
                pointerEvents: 'none',

                [`& ${AccordionButton}`]: {
                    color: '$neutral300',
                },
            },
        },

        variant: {
            Default: {
                bgc: '$neutral50',
                border: '1px solid $neutral50',

                '&:hover': {
                    border: '1px solid $primary600',
                },
            },

            Secondary: {
                bgc: '$primary200',
                border: '1px solid $primary200',

                '&:hover': {
                    border: '1px solid $primary300',
                },

                [`& ${AccordionButton}`]: {
                    bgc: '$primary200',
                },

                [`& ${AccordionContent}`]: {
                    bgc: '$neutral50',
                    color: '$primary600',
                    p: '$3',
                },
            },

            Pleasant: {},
        },

        isOpen: {
            true: {
                bgc: '$white',
                border: '1px solid $primary600',

                [`& ${AccordionButton}`]: {
                    color: '$primary600',

                    [`& ${ArrowWrapper}`]: {
                        [`& ${StyledSVG}`]: {
                            transform: 'rotate(180deg)',
                        },
                    },
                },

                [`& ${AccordionContent}`]: {
                    mt: '-$2',
                },
            },
        },
        canOverflow: {
            true: {
                overflow: 'unset',
            },
        },
    },

    compoundVariants: [
        {
            variant: 'Secondary',
            isOpen: true,
            css: {
                border: '1px solid $primary200',

                [`& ${AccordionButton}`]: {
                    color: '$primary600',

                    [`& ${ArrowWrapper}`]: {
                        [`& ${StyledSVG}`]: {
                            transform: 'rotate(180deg)',
                        },
                    },
                },

                [`& ${AccordionContent}`]: {
                    mt: 0,
                },
            },
        },
        {
            variant: 'Pleasant',
            disabled: true,
            css: {
                color: '$primary600',

                [`& ${AccordionButton}`]: {
                    color: '$primary600',
                },
            },
        },
    ],
})
